import { FC, useMemo } from 'react'
import DuoPush, { DuoPushProps } from 'src/components/DuoPush'
import { ButtonTransformer } from 'src/relay/Transformers/ButtonTransormer'
import { ImageTransformer } from 'src/relay/Transformers/ImageTransformer'
import { getThemeColor } from 'src/relay/Transformers/ThemeTransformer'

import { BlockProps } from '../props'

import { ColumnedImageTextBlockProps } from './props'

const ColumnedImageTextBlock: FC<BlockProps<ColumnedImageTextBlockProps>> = ({
  data,
}) => {
  const props: DuoPushProps = useMemo(
    () => ({
      ...(data.title && {
        blockTitleProps: {
          title: data.title,
          actionButtonProps: ButtonTransformer({
            data: data.cta,
            theme: data.theme?.data,
          }),
        },
      }),
      color: getThemeColor(data.theme?.data),
      pushes: data?.columnedImageContent?.map((push) => {
        // Strapi v4 wraps media as `{ data: { ... } }`; v5 returns it flat.
        // Unwrap once so the transformer can read either shape.
        const desktopImage: any =
          (push?.desktopImage as any)?.data ?? push?.desktopImage
        const mobileImage: any =
          (push?.mobileImage as any)?.data ?? push?.mobileImage
        const imageProps = ImageTransformer(desktopImage, {
          tablet: '100vw, 50vw',
        })
        const mobileImageProps = ImageTransformer(mobileImage, {
          tablet: '100vw, 50vw',
        })
        return {
          title: push.title,
          // Only emit `pictureProps` when we have a valid desktop image.
          // Passing `imageProps: undefined` makes `<Picture>` return `null`,
          // which leaves the surrounding motion observer with a null DOM ref
          // and crashes framer-motion with "Invalid value used as weak map key".
          ...(imageProps && {
            pictureProps: {
              imageProps,
              ...(mobileImageProps && { mobileImageProps }),
            },
          }),
          richtextProps: {
            html: push.text || '',
          },
        }
      }),
    }),
    [data]
  )

  return <DuoPush {...props} />
}

export default ColumnedImageTextBlock
